module.exports = __webpack_public_path__ + "static/media/ky.58b6db25.svg";